import { render, staticRenderFns } from "./OutcomeDetailsTable.vue?vue&type=template&id=df0f2872&scoped=true&"
import script from "./OutcomeDetailsTable.vue?vue&type=script&lang=js&"
export * from "./OutcomeDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./OutcomeDetailsTable.vue?vue&type=style&index=0&id=df0f2872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0f2872",
  null
  
)

export default component.exports